export const categories = [
  { slug: "dianying", name: "电影", icon: "ri-movie-2-line", description: "最新热门电影高清在线观看" },
  { slug: "dianshiju", name: "电视剧", icon: "ri-tv-2-line", description: "热门电视剧全集免费看" },
  { slug: "zongyi", name: "综艺", icon: "ri-emotion-laugh-line", description: "火爆综艺节目不间断" },
  { slug: "dongman", name: "动漫", icon: "ri-ghost-line", description: "日漫国漫精彩放送" },
  { slug: "jilupian", name: "纪录片", icon: "ri-film-line", description: "高分纪录片深度探索" },
  { slug: "duanju", name: "短剧", icon: "ri-smartphone-line", description: "精彩短剧刷不停" },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});